import RegularField from './RegularField';

export default RegularField;
